import React from 'react';
import { FEATURES, isFeatureEnabled } from 'utilities/features';
import { appLogin, webLogin } from 'actions/User';
import Button from 'components/UI/Button';
import ButtonRow from 'components/UI/ButtonRow';
import CartDeliverTo from 'components/Cart/CartDeliverTo';
import PlaceOrderButton from 'components/PlaceOrderButton';
import { CheckoutCvc } from 'checkout';
import { connect, useDispatch } from 'react-redux';
import { gotoCheckoutPage } from 'actions/Checkout';
import { toggleCart } from 'actions/UI';
import './CartCheckout.scss';
import { PaymentMethodType } from 'types/paymentMethodType';
import { useTranslation } from 'react-i18next';
function CartCheckout({ oneClickCheckoutEnabled, hasItemsInCart, isLoggedIn, isLoginEnabled, address, isApp, canDeliverToAddress, deliveryDate, isGift, distributionLoading, showCvcInput, canGoToCartOnly, }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const goToCheckout = () => {
        dispatch(toggleCart(false));
        dispatch(gotoCheckoutPage('SINGLE_ORDER'));
    };
    return (React.createElement("div", { className: "cart-checkout" }, hasItemsInCart && (React.createElement("div", null,
        canGoToCartOnly && (React.createElement(ButtonRow, null,
            React.createElement(Button, { variant: "primary", disabled: !canDeliverToAddress, className: "go-to-checkout-btn", onClick: () => goToCheckout() }, t('cartCartCheckoutGotoCheckout')))),
        !isLoggedIn && isLoginEnabled && (React.createElement("div", { className: "cart-checkout__checkout-details" },
            t('cartCartCheckoutLoginIntro'),
            React.createElement("br", null),
            React.createElement(Button, { variant: "text", onClick: () => (isApp ? appLogin() : webLogin()) }, t('cartCartCheckoutLogin')))),
        !canGoToCartOnly && (React.createElement("div", null,
            !isGift && !showCvcInput && (React.createElement(CartDeliverTo, { address: address, date: deliveryDate })),
            showCvcInput && !isGift && (React.createElement("div", { className: "cart-checkout__cvc" },
                React.createElement(CheckoutCvc, null))),
            React.createElement(ButtonRow, { style: "equal" },
                (!showCvcInput || isGift) && (React.createElement(Button, { variant: "secondary", onClick: () => goToCheckout() }, t('cartCartCheckoutGotoCheckout'))),
                !isGift && (React.createElement(PlaceOrderButton, { idPrefix: "cartCheckout", disabled: !canDeliverToAddress || distributionLoading || isGift })))))))));
}
const mapStateToProps = ({ user, address, cart, paymentMethod, newPaymentMethod, checkout, distribution, gift, ui, features, }) => {
    const paymentMethodTypeIsVipps = checkout.paymentMethodType === PaymentMethodType.VIPPS;
    const canGoToCartOnly = !features.oneClickCheckoutEnabled || paymentMethodTypeIsVipps || newPaymentMethod.active;
    return {
        address: address.active,
        canDeliverToAddress: distribution.canDeliver,
        isApp: ui.isApp,
        isLoggedIn: user.isLoggedIn,
        isLoginEnabled: isFeatureEnabled(features, FEATURES.LOGIN),
        preferredPaymentMethod: paymentMethod.preferred,
        oneClickCheckoutEnabled: features.oneClickCheckoutEnabled,
        hasItemsInCart: cart.products.length > 0,
        deliveryDate: checkout.deliveryDate,
        isGift: gift.isGift,
        distributionLoading: distribution.distributionLoading,
        showCvcInput: ui.showCvcInput && !(cart.total === 0),
        canGoToCartOnly,
    };
};
export default connect(mapStateToProps)(CartCheckout);
